// extracted by mini-css-extract-plugin
module.exports = {"loader":"OptionsLoader_loader__hyk2V","svg":"OptionsLoader_svg__DwD5T"};